import styled from 'styled-components';
import { colorLegible } from '../../utils';

export const TablaGeneralStyles = styled.table`
  & thead tr {
    height: ${props => props.theadRowHeight || ''};
  }
  & tbody tr:not(.expanded) {
    height: ${props => props.tbodyRowHeight || ''};
  }
  & tbody tr:not(.expanded):nth-child(odd) {
    background-color: ${props => props.oddStripesColor || ''};
  }
  & tbody tr:not(.expanded):nth-child(even) {
    background-color: ${props => props.evenStripesColor || ''};
  }
  & tbody tr:not(.expanded):hover th,
  & tbody tr:not(.expanded):hover td {
    background-color: ${props => props.hoverColor || ''};
    color: ${props => (props.hoverColor ? colorLegible(props.hoverColor) : '')};
  }
`;
